export default "__VITE_PUBLIC_ASSET__04e8bed3__"